import React, { Fragment } from "react";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";

import SecondaryButton from "./SecondaryButton";

const CancelButton = ({ onClick, ...other }) => (
  <SecondaryButton onClick={onClick} {...other}>
    <CloseIcon />
    <div>CANCEL</div>
  </SecondaryButton>
);
export default CancelButton;
